export const config = {
    appName: 'Stupendo.us',
    appVersion: 'v0.5.0',
    apiUrl: 'https://stupendo.us/cockpit/api/',
    apiKey: '306ab10e35680019559b9beb73f9bc',
    gaID: 'UA-120907051-1',
    recaptchaSitekey: '6Lc4Kl8UAAAAAHXF2esGqWY0d8qUGFxHkUolKl-M',
    facebookAppId: '419974605144013',
    debug: false
};
